"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/VideoCall/Permissions.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _videoRoom = require('web/selectors/videoRoom');
var _videoCall = require('web/selectors/videoCall');
var _videoCall3 = require('web/services/videoCall');
var _ui = require('web/services/ui');
var _hooks = require('web/services/hooks');
var _VideoCall = require('web/components/VideoCall');
var _RoomHeader = require('web/components/VideoCall/RoomHeader'); var _RoomHeader2 = _interopRequireDefault(_RoomHeader);

var _useClassState = require('./useClassState');











// Read once per instance, as the class fields were.
const detectBrowser = () => {
  const isChrome = navigator.userAgent.includes("Chrome")
  const isSafari = navigator.userAgent.includes("Safari") && !isChrome
  return { isChrome, isSafari }
}

// Was a class inside connect(): memo keeps connect's props bail-out.
const PermissionsScreen = ({
  onRoomLinkCopy,
  openMobileMoreOptionsModal,
}) => {
  const roomName = _hooks.useAppSelector.call(void 0, _videoRoom.selectCurrentVideoRoomName)
  const roomLink = _hooks.useAppSelector.call(void 0, _videoRoom.selectCurrentVideoRoomLink)
  const arePermsBlocked = _hooks.useAppSelector.call(void 0, _videoCall.selectArePermsBlocked)

  const [state, setState] = _useClassState.useClassState(() => ({
    arePermsProbed: false,
    isMobileScreen: _ui.isMobileScreen.call(void 0, ),
  }))
  const [{ isChrome, isSafari }] = _react.useState.call(void 0, detectBrowser)
  const probingTimeout = _react.useRef(null)

  // Each probe starts a new 1.5s timer without clearing the previous one; only
  // the latest is cleared on unmount (as before).
  const probePerms = _react.useCallback.call(void 0, async () => {
    probingTimeout.current = setTimeout(() =>
      setState({ arePermsProbed: true })
    , 1500)

    const manager = new (0, _videoCall3.StreamManager)({
      useMic: true,
      useCam: true,
      permsProbing: true,
    })
    await manager.update().catch(() => null)

    manager.stop()
  }, [setState])

  const handleOpenMobileMoreOptionsModal = _react.useCallback.call(void 0, () =>
    openMobileMoreOptionsModal({ isSettingsLinkEnabled: false }), [openMobileMoreOptionsModal])

  // componentDidMount / componentWillUnmount: both deps never change
  // (`isMobileScreen` is only set in the initial state; probePerms is stable).
  const { isMobileScreen } = state
  _react.useLayoutEffect.call(void 0, () => {
    if (!isMobileScreen) probePerms()
    return () => {
      if (probingTimeout.current !== null) clearTimeout(probingTimeout.current)
    }
  }, [isMobileScreen, probePerms])

  return (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement(_RoomHeader2.default, {
        roomName: roomName,
        roomLink: roomLink,
        onRoomLinkCopy: onRoomLinkCopy,
        openMobileMoreOptionsModal: handleOpenMobileMoreOptionsModal, __self: this, __source: {fileName: _jsxFileName, lineNumber: 77}}
      )
      , _react2.default.createElement(_VideoCall.Permissions, {
        triggerPermsPrompt: probePerms,
        arePermsBlocked: arePermsBlocked,
        arePermsProbed: state.arePermsProbed,
        isMobileScreen: isMobileScreen,
        isSafari: isSafari,
        isChrome: isChrome, __self: this, __source: {fileName: _jsxFileName, lineNumber: 83}}
      )
    )
  )
}

exports. default = _react.memo.call(void 0, PermissionsScreen)
